export default __webpack_public_path__ + "static/media/hht1_ep12_timeline_02_blank.994065b5.png";